export default "__VITE_ASSET__175479aa__"